import { createValidation } from '../../../utils/validation';

export const createComplaintSampleInspectionValidation = (fields) => {
  const validation = createValidation(fields);
  return {
    schema: validation.schema,
    validateData: validation.validateData,
    validateComplaintSampleInspectionData: validation.validateData,
    validateField: validation.validateField
  };
};

export default createComplaintSampleInspectionValidation;

